import { useAuthStore } from '@/modules/authStore/stores/authStore'
import { useUnreadMessages } from '@/modules/chat-matrix-fast/composables/useUnreadMessages'

// Глобальный экземпляр для управления непрочитанными сообщениями в заголовке.
// Слушатели visibilitychange инициализируются внутри composable (идемпотентно).
export const globalUnreadMessages = useUnreadMessages()

/** Единая проверка авторизации для всех экшенов стора */
export function checkAuth(): boolean {
  return useAuthStore().isAuthenticated === true
}

/** Восстановление сессии: не слать read receipt до явного просмотра. */
let suppressAutoReadReceipt = false

export function setSuppressAutoReadReceipt(value: boolean): void {
  suppressAutoReadReceipt = value
}

export function shouldSuppressAutoReadReceipt(): boolean {
  return suppressAutoReadReceipt
}
